import {
  deleteRequest,
  downPostRequest,
  getRequest,
  postRequest,
  putRequest,
  getRequestRestFul,
} from "@/config/request";
import { SYS_BASE_URL } from "@/constant/Const";

export const userListPaging = (data) => {
  return postRequest(SYS_BASE_URL + "/api/user/list-paging", data);
};

export const updateUser = (data) => {
  return putRequest(SYS_BASE_URL + "/api/user/update", data);
};

export const createUser = (data) => {
  return postRequest(SYS_BASE_URL + "/api/user/save", data);
};

export const deleteUser = (data) => {
  return deleteRequest(SYS_BASE_URL + "/api/user/delete", data);
};

// export const unbindTenantRole = (data) =>{
//     return putRequest(SYS_BASE_URL + "/api/user/unbindTenantRole",data);
// }

export const roleIdsByUserId = (data) => {
  return getRequestRestFul(
    SYS_BASE_URL + "/api/user/getBindRoleByUserId/" + data
  );
};

export const bindRole = (data) => {
  return putRequest(SYS_BASE_URL + "/api/user/bindRole", data);
};

// // export const updateUserRole = (data) =>{
// //     return putRequest("/auth/api/user/update-user-role",data);
// // }

// export const getUserInfo = (data) =>{
//     return getRequest(SYS_BASE_URL + "/api/user/userInfo",data);
// }

// export const authUser = (data) =>{
//     return postRequest(SYS_BASE_URL + "/api/user/authUser",data);
// }

//
export const getBindRoleByUserId = (data) => {
  return getRequest(SYS_BASE_URL + "/api/user/getBindRoleByUserId/" + data);
};

export const userBindRole = (data) => {
  return putRequest(SYS_BASE_URL + "/api/user/bindRole" , data);
};

export const userGetInfo = (data) => {
  return getRequest(SYS_BASE_URL + "/api/user/getInfo/" + data);
};